import * as XSS from 'xss'
import { FilterXSS } from 'xss'

//  We keep all default whitelist rules from XSS and allow `data-analytics` only on <a> tags.
const defaultWhiteList = { ...XSS.whiteList }
const mergedWhiteList = {
  ...defaultWhiteList,
  a: Array.from(new Set([...(defaultWhiteList.a ?? []), 'data-analytics']))
}

const xss = new FilterXSS({ whiteList: mergedWhiteList })

export function brxmRteContentFilter(input: string): string {
  return xss.process(String(input ?? ''))
}
